import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../images/logo.jpeg'
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav 
    
    style={{    height: '5.7rem'}}
     className="navbar-scrolled">
      <div className="navbar-container">
        <div className="navbar-content">
          {/* Logo */}
          <div className="navbar-logo">
            <Link to="/" className="logo-link">
              <img 
                src={logo} 
                alt="Staffing Support India" 
                className="logo-image"
              />
            </Link>
          </div>
          
          {/* Desktop Menu */}
          <div className="navbar-menu-desktop">
            <div className="navbar-links">
              <Link 
                to="/" 
                className={`nav-link ${isActive('/') ? 'nav-link-active' : ''}`}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className={`nav-link ${isActive('/about') ? 'nav-link-active' : ''}`}
              >
                About
              </Link>
              <Link 
                to="/services" 
                className={`nav-link ${isActive('/services') ? 'nav-link-active' : ''}`}
              >
                Services
              </Link>
          
              <Link 
                to="/career" 
                className={`nav-link ${isActive('/career') ? 'nav-link-active' : ''}`}
              >
                Career
              </Link>
                  <Link 
                to="/contact" 
                className={`nav-link ${isActive('/contact') ? 'nav-link-active' : ''}`}
              >
                Contact
              </Link>
              {/* <Link 
                to="/blog" 
                className={`nav-link ${isActive('/blog') ? 'nav-link-active' : ''}`}
              >
                Blog
              </Link> */}
            </div>
          </div>
          
          {/* Mobile menu button */}
          <div className="navbar-menu-mobile">
            <button
              onClick={toggleMenu}
              className="mobile-menu-button"
            >
              <span className="sr-only">Open main menu</span>
              <div className="hamburger-icon">
                <span className={`hamburger-line ${isMenuOpen ? 'hamburger-line-1-open' : 'hamburger-line-1'}`}></span>
                <span className={`hamburger-line ${isMenuOpen ? 'hamburger-line-2-open' : 'hamburger-line-2'}`}></span>
                <span className={`hamburger-line ${isMenuOpen ? 'hamburger-line-3-open' : 'hamburger-line-3'}`}></span>
              </div>
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'mobile-menu-open' : 'mobile-menu-closed'}`}>
        <div className="mobile-menu-content">
          <Link 
            to="/" 
            className={`mobile-nav-link ${isActive('/') ? 'mobile-nav-link-active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`mobile-nav-link ${isActive('/about') ? 'mobile-nav-link-active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            About
          </Link>
          <Link 
            to="/services" 
            className={`mobile-nav-link ${isActive('/services') ? 'mobile-nav-link-active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Services
          </Link>
               <Link 
            to="/career" 
            className={`mobile-nav-link ${isActive('/career') ? 'mobile-nav-link-active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Career
          </Link>
          <Link 
            to="/contact" 
            className={`mobile-nav-link ${isActive('/contact') ? 'mobile-nav-link-active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>
     
          {/* <Link 
            to="/blog" 
            className={`mobile-nav-link ${isActive('/blog') ? 'mobile-nav-link-active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Blog
          </Link> */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

